import dayjs from 'dayjs';
import 'dayjs/locale/it';

dayjs.locale('it');

/**
 * Escapes CSV values that contain commas, quotes, or newlines
 * @param {any} value - The value to escape
 * @returns {string} - Escaped CSV value
 */
const escapeCSV = (value) => {
  if (value === null || value === undefined) return '';
  const stringValue = String(value);
  if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

/**
 * Exports teacher reports data to CSV file
 * @param {Array} data - Array of teacher report objects
 */
export const exportTeacherReportsToCSV = (data) => {
  if (!data || data.length === 0) {
    return;
  }

  // CSV Headers
  const headers = [
    'Docente',
    'Corso',
    'Iscritti',
    'Date',
    'Presenti Medi',
    'Numero Pagamenti',
    'Totale Euro'
  ];

  // Convert data to CSV format
  const csvRows = data.map(row => [
    row.teacher || '',
    row.course || '',
    row.totalEnrollments || 0,
    row.datesRatio || '0/0',
    row.averagePresent || 0,
    row.totalPayments || 0,
    `€${row.totalAmount || 0}`
  ]);

  // Create CSV content
  const csvContent = [
    headers.map(escapeCSV).join(','),
    ...csvRows.map(row => row.map(escapeCSV).join(','))
  ].join('\n');

  // Create blob and download file
  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `report_docenti_corsi_${dayjs().format('DD-MMM-YY')}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

